import { CatSkeleton } from 'components/blocks-components';
import { useCallback } from 'react';

const SideMenuLoader = () => {
  const getSkeletonLoader = useCallback((heightInPx) => {
    return (
      <div
        className="overflow-hidden mb-3"
        style={{ height: `${heightInPx}px` }}
      >
        <CatSkeleton size="xl" />
      </div>
    );
  }, []);
  return (
    <div>
      {getSkeletonLoader(48)}
      {getSkeletonLoader(48)}
    </div>
  );
};

export default SideMenuLoader;
